export default __webpack_public_path__ + "static/media/vegetables.58337775.svg";